class UserSessionService {
  constructor() {
    this.STORAGE_KEY = 'tth_user_session';
  }

  // Save user session data
  saveSession(data) {
    try {
      const sessionData = {
        ...data,
        timestamp: Date.now(),
      };
      console.log('Saving session data:', sessionData); // Debug log
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(sessionData));
      return true;
    } catch (error) {
      console.error('Error saving session:', error);
      return false;
    }
  }

  // Get user session data
  getSession() {
    try {
      const data = localStorage.getItem(this.STORAGE_KEY);
      console.log('Getting session data:', data); // Debug log
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error('Error getting session:', error);
      return null;
    }
  }

  // Update specific fields in session
  updateSession(fields) {
    try {
      const currentSession = this.getSession() || {};
      const updatedSession = { ...currentSession, ...fields };
      return this.saveSession(updatedSession);
    } catch (error) {
      console.error('Error updating session:', error);
      return false;
    }
  }

  // Clear session
  clearSession() {
    try {
      localStorage.removeItem(this.STORAGE_KEY);
      console.log('Session cleared'); // Debug log
      return true;
    } catch (error) {
      console.error('Error clearing session:', error);
      return false;
    }
  }

  // Check if session exists and is valid (not expired)
  isSessionValid(maxAgeHours = 24) {
    const session = this.getSession();
    if (!session || !session.timestamp) {
      return false;
    }
    
    const maxAgeMs = maxAgeHours * 60 * 60 * 1000;
    return (Date.now() - session.timestamp) < maxAgeMs;
  }
}

export default new UserSessionService(); 